import { useReportPageLoadedFromLinkClick } from '@ms/yammer-hooks/dist/pageLoad';
import { useTranslations } from '@ms/yammer-i18n-react';
import CommonStrings from '@ms/yammer-strings/dist/Common';
import PanesStrings from '@ms/yammer-strings/dist/Panes';
import { useDeprecationBanner } from '@ms/yammer-web-components/dist/browserDeprecation/hooks';
import AppNavigation from '@ms/yammer-web-components/dist/navigation/AppNavigation';
import PageLayout from '@ms/yammer-web-core-ui/dist/components/PageLayout';
import React, { FC, Suspense, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import SuiteHeader from '../SuiteHeader';

import LoadableWebSubHeader from './LoadableWebSubHeader';

interface RoutePageLayoutProps {
  readonly collapseLeftSidebar?: boolean;
  readonly noScroll?: boolean;
  readonly noSpacing?: boolean;
}

const Page: FC<RoutePageLayoutProps> = ({
  collapseLeftSidebar = false,
  noScroll = false,
  noSpacing = false,
  children,
}) => {
  const suppressDismiss = true;
  const t = useTranslations(PanesStrings);
  const commonStrings = useTranslations(CommonStrings);
  const { pathname, search: queryString } = useLocation();
  const pathQueryString = `${pathname}${queryString}`;

  const getHeader = useCallback(() => <SuiteHeader />, []);

  const getSubHeader = useCallback(
    () => (
      <Suspense fallback={null}>
        <LoadableWebSubHeader />
      </Suspense>
    ),
    []
  );
  const getNavigation = useCallback(() => <AppNavigation />, []);

  const getBanner = useDeprecationBanner(suppressDismiss);

  useReportPageLoadedFromLinkClick();

  return (
    <PageLayout
      closeContentSidebarAriaLabel={commonStrings.commonClose()}
      collapseLeftSidebar={collapseLeftSidebar}
      noScroll={noScroll}
      noSpacing={noSpacing}
      onRenderHeader={getHeader}
      onRenderBanner={getBanner}
      onRenderLeftSidebar={getNavigation}
      onRenderSubHeader={getSubHeader}
      resetState={pathQueryString}
      showContentSidebarAriaLabel={t.showAdditionalInformationPane()}
    >
      {children}
    </PageLayout>
  );
};

export default Page;
